import { z } from 'zod'

// Схема для формы расчета
export const calculatorFormSchema = z.object({
  metalId: z.number().min(1, 'Выберите тип металла'),
  weight: z.number().min(1, 'Минимальный вес 1 кг'),
  needTransport: z.boolean().default(false),
  phone: z.string().min(10, 'Введите корректный номер телефона').optional(),
})

// Схема для формы заказа
export const orderFormSchema = z.object({
  name: z.string().min(2, 'Имя должно содержать минимум 2 символа'),
  phone: z.string().min(10, 'Введите корректный номер телефона'),
  address: z.string().min(5, 'Введите корректный адрес'),
  comments: z.string().optional(),
  // Добавляем данные из калькулятора
  metalName: z.string(),
  weight: z.number(),
  totalPrice: z.number(),
})

export type CalculatorFormData = z.infer<typeof calculatorFormSchema>
export type OrderFormData = z.infer<typeof orderFormSchema> 